export type Reference = {
  content: { [key: string]: string };
  display_date: string;
};

export class ReferenceData {
  constructor(private readonly content: { [key: string]: string | [] }, private readonly display_date: string) {}

  getReference(): any {
    return {
      content: this.content,
      display_date: this.display_date,
    };
  }
}
